<div class="page">
  <div class="page_content">
    <div class="page_content__header">
      <div class="page_content__title">Add Coupon Code</div>
    </div>
    <form #form="ngForm" name="addItemForm">
      <div class="page_content__add">
        <app-dropdown-admin
          class="dropdowncategories"
          [input_dropdown_title]="'Select Category*'"
          [input_dropdown_options]="categories"
          (selectedId)="onCategorySelect($event)"
          [resetSelection]="resetDropdown"
        />

        <app-dropdown-admin
          class="dropdowncategories"
          [input_dropdown_title]="'Select Menu Items*'"
          [input_dropdown_options]="menuItems"
          (selectedId)="onMenuItemSelect($event)"
          [resetSelection]="resetDropdown"
        />

        <div class="couponcode">
          <input
            type="text"
            class="item_input item_input--small"
            placeholder="Code*"
            [(ngModel)]="model.couponCode"
            name="couponCode"
          />
        </div>
        <div class="couponcode">
          <input
            type="text"
            class="item_input item_input--small"
            placeholder="price After*"
            [(ngModel)]="afterDiscountPrice"
            name="afterDiscount"
          />
        </div>
      </div>
      <div class="save_button" (click)="onFormSubmit()">
        <app-save-button />
      </div>
    </form>

    <div class="page_content__header">
      <div class="page_content__title">Coupons</div>
    </div>

    <div class="header">
      <app-coupon-header />
    </div>

    <div class="table">
      @for (coupon of coupons; track coupon.couponID) {
      <app-coupon-row
        [Id]="coupon.couponID"
        [ItemId]="coupon.menuItem.id"
        [Code]="coupon.couponCode"
        [isVisible]="coupon.isActive"
        (deleted)="loadCoupons()"
      />
      <hr class="line" />
      }
    </div>
  </div>
</div>

<app-admin-success-message />
